'use strict';

export class ReportStatusCtrl
{
	$scope;
	$mdDialog;
	cfg;
	
	
	constructor($scope, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$mdDialog = $mdDialog;
		this.cfg = jsDataService.get('cfgReportStatus', {});
	}
	
	changeStatus(ev){
		
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "jsDataService", "cfg", this.dialogCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'projects/ng_status.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: true,
			fullscreen: true,
			locals: {
				cfg: this.cfg
			}
		}).then((results) => {
			if(this.cfg.submitUrl){
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.submitUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	dialogCtrl($scope, $mdDialog, jsDataService, cfg){
		const classif = jsDataService.get('cfgClassif', {});
		if(typeof(cfg.classifId) === 'undefined'){
			cfg.classifId = 'periodic_report_status';
		}
		$scope.dialogTitle = cfg.dialogTitle;
		$scope.fieldTitle = cfg.fieldTitle;
		$scope.statuses = [];
		if(typeof(classif[cfg.classifId]) !== 'undefined'){
			$scope.statuses = classif[cfg.classifId];
		}
		
		$scope.postElements = {
			status: cfg.status
		};
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function() {
			$mdDialog.hide($scope.postElements);
		};
	}
}